export default {"src":"/_next/static/media/0xca2a7068e551d5c4482eb34880b194e4b945712f.567de922.svg","height":128,"width":128,"blurWidth":0,"blurHeight":0};